import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Loader, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalButtonWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import PremiseService from '../../../../services/bioplus-services/premise';
import { PremiseSchema } from '../validator/validator';
import { getstateList } from '../../CompanyV2/helper/helper';
import { IntlMessages } from '../../../../helper/langHelper';
import { getCountryCode } from '../../UserInvitation/userInvitation';
import PinDropPremiseMap from './PinDropPremiseMap';
import { ModalWrapperTwoColumn, ModalGap } from './modal.styles';

const AddPremiseModal = ({ onClose, companyId, roleId, invalidateQuery }) => {
  const [state, setState] = useState();
  const [isProcessing, setIsProcessing] = useState(false);
  // { lat, lng } picked on the map, or null until the user drops a pin
  const [centroid, setCentroid] = useState(null);
  const queryClient = useQueryClient();

  const mutation = useMutation((premise) => PremiseService.create(premise), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(invalidateQuery || 'premises');
      setIsProcessing(false);
      onClose();
    },
    onError: (error) => {
      setIsProcessing(false);
      alert(error);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      ...(state && { addressState: state }),
      ...(centroid && {
        // Stored as strings to match how masterCentroid is already consumed
        // elsewhere (e.g. the geofence map does
        // Number(masterGeofence?.masterCentroid?.latitude) when computing bounds).
        masterCentroid: {
          latitude: String(centroid.lat),
          longitude: String(centroid.lng),
        },
      }),
    };
    setIsProcessing(true);
    mutation.mutate(value);
  };

  const validator = (values) => PremiseSchema.validate(values);
  const stateListBasedOnEnv = getstateList(process.env.REACT_APP_ENV);

  const handleSelectedValue = (value) => {
    setState(value.value);
  };
  const countryPhoneCode = getCountryCode(process.env.REACT_APP_ENV);

  const handleCentroidChange = (nextPosition) => {
    setCentroid(nextPosition);
  };

  return (
    <>
      <Modal isOpen={true} title={<IntlMessages id="button.text.addPremise" />}>
        <Form
          initialValues={{ companyId, roleId, contactNumber: countryPhoneCode }}
          validator={validator}
          onSubmit={handleSubmit}
        >
          <ModalWrapperTwoColumn>
            <ModalGap>
              <IntlMessages id="input.label.name">
                {(label) => <BioPlusTextField label={label} name="propertyName" fullWidth />}
              </IntlMessages>
              <IntlMessages id="input.label.propertyId">
                {(label) => <BioPlusTextField label={label} name="propertyId" fullWidth />}
              </IntlMessages>

              <IntlMessages id="label.street">
                {(label) => <BioPlusTextField label={label} name="addressStreet" fullWidth />}
              </IntlMessages>

              <IntlMessages id="label.town">
                {(label) => <BioPlusTextField label={label} name="addressTown" fullWidth />}
              </IntlMessages>

              <IntlMessages id="input.label.contact.name">
                {(label) => <BioPlusTextField label={label} name="contactName" fullWidth />}
              </IntlMessages>

              <IntlMessages id="input.label.contact.email">
                {(label) => <BioPlusTextField label={label} name="contactEmail" fullWidth />}
              </IntlMessages>

              <IntlMessages id="input.label.contact.phone">
                {(label) => <BioPlusTextField label={label} name="contactNumber" fullWidth />}
              </IntlMessages>

              <IntlMessages id="text.selectTheState">
                {(label) => (
                  <DropDown
                    options={stateListBasedOnEnv}
                    selectedOption={handleSelectedValue}
                    name="addressState"
                    placeholder={label}
                  />
                )}
              </IntlMessages>
            </ModalGap>

            <PinDropPremiseMap value={centroid} onChange={handleCentroidChange} />

            <ModalButtonWrapper style={{ gridColumn: '1 / -1' }}>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              {isProcessing ? (
                <Button varient="normal" disabled={isProcessing}>
                  <div style={{ paddingRight: '10px' }}></div>
                  <IntlMessages id="button.text.processing" />
                  <Loader size="small" isNotRequiredLoadingText={true} />
                </Button>
              ) : (
                <Button varient="normal" type="submit" disabled={isProcessing || !centroid}>
                  <IntlMessages id="modal.button.submit" />
                </Button>
              )}
            </ModalButtonWrapper>
          </ModalWrapperTwoColumn>
        </Form>
      </Modal>
    </>
  );
};

export default AddPremiseModal;
